import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import database from "../config/firebaseConfig";
import WebsiteFooter from "../components/WebsiteFooter";
import "./styles/Combos.css";

const Combos = ({ addToCart }) => {
  const [products, setProducts] = useState([]);
  const [productsMap, setProductsMap] = useState({});
  const [isExpanded, setIsExpanded] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const snapshot = await database.ref("Products").once("value");
        if (snapshot.exists()) {
          const allProducts = snapshot.val();
          const productsArray = Object.values(allProducts);

          // Create a map for quick lookup: { "Plain Murukku": {...}, "Curry Cookies": {...} }
          const productLookup = {};
          Object.keys(allProducts).forEach((key) => {
            productLookup[allProducts[key].Name] = allProducts[key];
          });

          setProductsMap(productLookup);
          setProducts(productsArray.filter((product) => product.isCombo)); // Filter combos only
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const handleNavigation = (productName) => {
    const timestamp = new Date().toISOString();
    window.gtag("event", `Product_${productName}_viewed`, {
      'timestamp': timestamp.toLocaleString(),
      "click": productName
    });
    navigate(`/Product/${productName}`);
  };

  const handleAddToCart = (e, product) => {
    e.stopPropagation();
    if (!addToCart) {
      console.error("addToCart function is undefined!");
      return;
    }

    const productToCart = {
      Name: product.Name,
      Price: product.Price,
      Img: product.Img[0] || "/placeholder.jpg"
    };

    addToCart(productToCart, 1);
  };

  const handleReadMore = (e, comboName) => {
    e.stopPropagation();
    setIsExpanded((prev) => ({ ...prev, [comboName]: !prev[comboName] }));
  };

  return (
    <>
      <div className="combo-category-container">
        <h2 className="combo-category-title">{products.Category}</h2>
        {products.length > 0 ? (
          products.map((combo, index) => (
            <div className="combo-card" onClick={() => handleNavigation(combo.Name)}>
              <div className="product-grid">
                {Array.isArray(combo.Products) &&
                  combo.Products.map((productName, i) => {
                    const product = productsMap[productName]; // Get product details using the lookup map
                    return (
                      <img
                        key={i}
                        src={product?.Img[0] || "/placeholder.jpg"}
                        alt={product?.Name || "Unknown Product"}
                        className="combo-image"
                      />
                    );
                  })}
              </div>

              <div className="combo-info">
                <h3>{combo.Name}</h3>
                <div className="item-card-desc">
                  {isExpanded[combo.Name] ? combo["Desc"] : `${combo["Desc"].slice(0, 50)}...`}
                  {!isExpanded[combo.Name] && combo["Desc"].length > 50 && (
                    <span className="read-more" onClick={(e) => handleReadMore(e, combo.Name)}>
                      (Read more)
                    </span>
                  )}
                  {isExpanded[combo.Name] && (
                    <span className="read-less" onClick={(e) => handleReadMore(e, combo.Name)}>
                      (Read less)
                    </span>
                  )}
                </div>
                <div className="price-weight-list">Rs. {combo.Price}</div>
                <div className="card-actions">
                  <button className="ATC-button" onClick={(e) => handleAddToCart(e, combo)}>
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>

          ))
        ) : (
          <p>Loading combo products...</p>
        )}
      </div>
      <WebsiteFooter />
    </>
  );
};

export default Combos;
